/**
 * PostHog Event Testing Utility
 * 
 * This file contains helper functions to test PostHog event tracking
 * in your development environment.
 */

// Test function to manually trigger events for debugging
export const testPostHogEvents = (posthog) => {
  if (!posthog) {
    console.warn('PostHog not initialized');
    return;
  }

  console.log('🧪 Testing PostHog Events...');
  
  // Test basic event
  posthog.capture('test_event', {
    test_property: 'test_value',
    timestamp: new Date().toISOString()
  });
  
  // Test page view
  posthog.capture('page_view', {
    page: 'test_page',
    timestamp: new Date().toISOString()
  });

  // Test user identify
  posthog.identify('test_user_' + Date.now(), {
    email: 'test@example.com',
    name: 'Test User'
  });

  console.log('✅ Test events sent to PostHog');
  console.log('📊 Check your PostHog dashboard in a few minutes to see the events');
};

// Helper to check PostHog status
export const checkPostHogStatus = (posthog) => {
  if (!posthog) {
    console.log('❌ PostHog not initialized');
    return false;
  }
  
  console.log('✅ PostHog initialized successfully');
  console.log('🔑 API Key:', process.env.REACT_APP_POSTHOG_KEY ? 'Set' : 'Missing');
  console.log('🏠 Host:', process.env.REACT_APP_POSTHOG_HOST || 'Not set');
  console.log('🐛 Debug mode:', process.env.NODE_ENV === 'development' ? 'Enabled' : 'Disabled');
  
  return true;
};

// Add to window for browser console testing
if (typeof window !== 'undefined') {
  window.testPostHog = testPostHogEvents;
  window.checkPostHogStatus = checkPostHogStatus;
}